export enum Priority {
  'low' = 'low',
  'normal' = 'normal',
  'high' = 'high',
}